/**
 * Created by valerasiestov on 17.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.table = (function () {
    "use strict";

    var controls = {},
        core = {
            addEvent: function (objects, event, handler) {
                var count = objects.length,
                    i;

                for (i = 0; i < count; i++) {
                    objects[i].addEventListener(event, handler, false);
                }
            }
        },
        handlers = {
            showButtonsClick: function () {
                var block = this.parentNode.parentNode.nextElementSibling.querySelector('.offer__tablet-info'),
                    blockWrap = block.querySelector('.offer__tablet-info-wrap'),
                    jBlock = $(block);

                this.classList.toggle('active');

                if (!block.classList.contains('active')) {

                    jBlock.slideDown(function () {
                        block.classList.toggle('active');
                        block.style.cssText = '';
                    });

                    setTimeout(function () {
                        block.classList.toggle('animate');
                    }, 200);

                } else {
                    block.classList.toggle('animate');

                    $(block).slideUp(function () {
                        block.classList.toggle('active');
                        block.style.cssText = '';
                    });

                }

            },

            closeButtonsClick: function () {
                var block = this.parentNode,
                    anotherButton = block.parentNode.parentNode.previousElementSibling.querySelector('.table-button-show');

                anotherButton.classList.remove('active');
                block.classList.remove('animate');

                $(block).slideUp(function () {
                    block.classList.toggle('active');
                    block.style.cssText = '';
                });
            }
        };

    function setEventList() {
        core.addEvent(controls.showButtons, 'click', handlers.showButtonsClick);
        core.addEvent(controls.closeButtons, 'click', handlers.closeButtonsClick);
    }

    function getControls() {
        controls.showButtons = document.querySelectorAll('.table-button-show');
        controls.closeButtons = document.querySelectorAll('.offer__tablet-close');
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}());

window.addEventListener('DOMContentLoaded', function () {

    module.table.init({

    });

}, false);
